import store from '/bubble-button/src/redux/store';
import PostMessageProcessor from '/bubble-button/src/common/js/lib/PostMessageProcessor';
import queryString from 'query-string';

import actionSetVisitorDomain from '/bubble-button/src/common/js/redux/actions/visitor/actionSetVisitorDomain';
import actionSetChatIsClosed from '/bubble-button/src/redux/actions/chat/actionSetChatIsClosed';
import actionSetChatIsOpen from '/bubble-button/src/redux/actions/chat/actionSetChatIsOpen';

class Setup {
    static parsedQuery() {
        return queryString.parse(location.search);
    }

    static application() {
        const parsedQueryString = this.parsedQuery();
        const parentDomain = decodeURIComponent(parsedQueryString.visitorDomain)
        store.dispatch(actionSetVisitorDomain(parentDomain));
        if (parsedQueryString.pageLoadChatOpenState === 'true') {
            store.dispatch(actionSetChatIsOpen());
        } else {
            store.dispatch( actionSetChatIsClosed());
        }
        PostMessageProcessor.init('chatBubbleButton', parentDomain);
    }
}

export default Setup;



// WEBPACK FOOTER //
// ./lib/Setup.js